import type { ReactNode } from "react";

type NavigationShellProps = {
  mobileHeader: ReactNode;
  rail: ReactNode;
  voiceDockVisible: boolean;
};

/**
 * Navigation chrome for the workspace: mobile app bar (plus the spacers that
 * offset its fixed positioning) and the desktop space rail. The Electron drag
 * region lives in DesktopTitleBar. Rendered as a fragment so each piece stays a direct child of the
 * layout flex container in ChatLayout.
 */
function NavigationShell({ mobileHeader, rail, voiceDockVisible }: NavigationShellProps) {
  return (
    <>
      {mobileHeader}
      {/* Spacer matching the fixed mobile app bar height */}
      <div className="sm:hidden" style={{ height: 'calc(env(safe-area-inset-top) + 64px)' }} />
      {/* Extra spacer when the voice dock is visible below the header */}
      {voiceDockVisible && <div className="sm:hidden" style={{ height: 52 }} />}
      {rail}
    </>
  );
}

export default NavigationShell;
